import { useState } from 'react'
import { useBahasa } from '../../../app/i18n'
import {
  Bendera, KepalaHalaman, PenyediaSimpan, Tab, TombolSimpanKepala,
} from '../../../shared/ui'
import FieldProfil from './FieldProfil'
import Persona from './Persona'
import JadwalBalas from './JadwalBalas'
import Model from './Model'

/**
 * CHATBOT — empat tab, mengikuti `DESAIN_BACKOFFICE.md`:
 * Persona & kebijakan · Data prospek · Jadwal balas · Model.
 *
 * "Data prospek" dan "Model" sudah ada sebagai layar berdiri sendiri sebelum ini; yang
 * berubah cuma tempatnya. Mereka memang bukan menu — keduanya menjawab pertanyaan yang
 * sama ("bagaimana bot ini berperilaku"), dan memisahkannya jadi menu membuat orang
 * mencari di tiga tempat untuk satu keputusan.
 *
 * "Persona & kebijakan" SUDAH BISA DIUBAH sejak migrasi 0030. Sebelumnya identitas bot
 * adalah teks di `app/ai/prompts/percakapan.py`, tersebar di sebelas tempat, dan tab ini
 * cuma menyatakan keadaannya. Sekarang ia setelan tenant, disisipkan ke prompt di satu
 * titik — `service.py::_safe_llm_reply`.
 */
export default function Chatbot() {
  const { t } = useBahasa()
  const [tab, setTab] = useState('persona')

  return (
    <PenyediaSimpan>
      <KepalaHalaman
        judul={t('ta.chatbotJudul')}
        keterangan={t('ta.chatbotKeterangan')}
        aksi={<TombolSimpanKepala t={t} />}
      />

      <Tab
        aktif={tab}
        set={setTab}
        daftar={[
          { id: 'persona', label: t('ta.tabPersona') },
          { id: 'prospek', label: t('ta.tabDataProspek') },
          { id: 'jadwal', label: t('ta.tabJadwalBalas') },
          { id: 'model', label: t('ta.tabModel') },
        ]}
      />
      {tab === 'persona' && <Persona />}
      {tab === 'prospek' && <FieldProfil />}
      {tab === 'jadwal' && <JadwalBalas kunci="chatbot" />}
      {tab === 'model' && <Model peran={['chat']} />}
    </PenyediaSimpan>
  )
}
